import { Injectable } from '@angular/core';
import { nameof, TwoWayAdapter, IModelMetadata } from '@bds/core';
import { FormGroupDescription, GridColumnDescription, IColumnDescription } from './adapter_t';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export class RtvUnitTrainTrip {
    constructor(
        public unitTrainId: string,
        public tripCount: number,
        public origState: string,
        public origCity: string,
        public locState: string,
        public locCity: string,
        public le: string,
        public destState: string,
        public destCity: string,
        public custNo: string,
        public custName: string,
        public commShortName: string,
        public commCode: string,
        public carStatus: string,
    ) {}
}

export const relationship: IModelMetadata[] = [
    { client: nameof<RtvUnitTrainTrip>('unitTrainId'), server: 'unitTrainId' },
    { client: nameof<RtvUnitTrainTrip>('tripCount'), server: 'tripCount' },
    { client: nameof<RtvUnitTrainTrip>('origState'), server: 'origState' },
    { client: nameof<RtvUnitTrainTrip>('origCity'), server: 'origCity' },
    { client: nameof<RtvUnitTrainTrip>('locState'), server: 'locState' },
    { client: nameof<RtvUnitTrainTrip>('locCity'), server: 'locCity' },
    { client: nameof<RtvUnitTrainTrip>('le'), server: 'le' },
    { client: nameof<RtvUnitTrainTrip>('destState'), server: 'destState' },
    { client: nameof<RtvUnitTrainTrip>('destCity'), server: 'destCity' },
    { client: nameof<RtvUnitTrainTrip>('custNo'), server: 'custNo' },
    { client: nameof<RtvUnitTrainTrip>('custName'), server: 'custName' },
    { client: nameof<RtvUnitTrainTrip>('commShortName'), server: 'commShortName' },
    { client: nameof<RtvUnitTrainTrip>('commCode'), server: 'commCode' },
    { client: nameof<RtvUnitTrainTrip>('carStatus'), server: 'carStatus' },
];

@Injectable({
    providedIn: 'root',
})
export class RtvUnitTrainTripAdapter extends TwoWayAdapter<RtvUnitTrainTrip> {
    constructor() {
        super();
    }
    public metadata: IModelMetadata[] = relationship;
}

@Injectable({
    providedIn: 'root',
})
export class RtvUnitTrainTripMetadata implements GridColumnDescription, FormGroupDescription {
    constructor() {}
    getColumns(defaultVisibility: boolean = true): IColumnDescription[] {
        const columns = [
            {
                dataField: nameof<RtvUnitTrainTrip>('unitTrainId'),
                dataType: 'string',
                caption: 'Unit Train ID',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('tripCount'),
                dataType: 'number',
                caption: 'Trip Count',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('origCity'),
                dataType: 'string',
                caption: 'Origin City',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('origState'),
                dataType: 'string',
                caption: 'Origin State',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('destCity'),
                dataType: 'string',
                caption: 'Destination City',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('destState'),
                dataType: 'string',
                caption: 'Destination State',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('custNo'),
                dataType: 'string',
                caption: 'Customer No',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('custName'),
                dataType: 'string',
                caption: 'Customer Name',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('locCity'),
                dataType: 'string',
                caption: 'Location City',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('locState'),
                dataType: 'string',
                caption: 'Location State',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('le'),
                dataType: 'string',
                caption: 'Load/Empty',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('commCode'),
                dataType: 'string',
                caption: 'Commodity Code',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('commShortName'),
                dataType: 'string',
                caption: 'Commodity Name',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtvUnitTrainTrip>('carStatus'),
                dataType: 'string',
                caption: 'Car Status',
                visible: defaultVisibility,
            } as IColumnDescription,
        ];
        return columns;
    }

    getFormGroup(obj?: any): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({});
        formGroup.addControl(nameof<RtvUnitTrainTrip>('unitTrainId'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('tripCount'), new UntypedFormControl(0));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('origState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('origCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('locState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('locCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('le'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('destState'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('destCity'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('custNo'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('custName'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('commShortName'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('commCode'), new UntypedFormControl(''));
        formGroup.addControl(nameof<RtvUnitTrainTrip>('carStatus'), new UntypedFormControl(''));

        if (!!obj) {
            formGroup.setValue(obj);
        }

        return formGroup;
    }
}
